import { render, staticRenderFns } from "./PainelRankingTabela.vue?vue&type=template&id=2c07248c"
import script from "./PainelRankingTabela.vue?vue&type=script&lang=js"
export * from "./PainelRankingTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelRankingTabela.vue?vue&type=style&index=0&id=2c07248c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports